import { get } from 'lodash'
import mapSchema from 'models/api_v2/configurations/mapSchema'

const GET_CONFIG_KEY_VALUES = 'dofe-fo/apiv2/configuration/GET_CONFIG_KEY_VALUES'
const GET_CONFIG_KEY_VALUES_SUCCESS = 'dofe-fo/apiv2/configuration/GET_CONFIG_KEY_VALUES_SUCCESS'
const GET_CONFIG_KEY_VALUES_FAIL = 'dofe-fo/apiv2/configuration/GET_CONFIG_KEY_VALUES_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  // Configuration values in the legacy (v1) shape, keyed by configuration key
  // This is the only map every consumer in FrontOffice uses
  values: {},
}

// Maps the new ConfigurationDto list to the legacy (v1) shape keyed by config key name,
// so existing consumers reading configuration.values[KEY].booleanValue etc. keep working.
function mapDtoListToValues(dtoList = []) {
  const values = {}

  dtoList.forEach(dto => {
    const keyName = get(dto, 'key.name.type')

    if (keyName) {
      values[keyName] = mapSchema(dto)
    }
  })

  return values
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONFIG_KEY_VALUES:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_KEY_VALUES_SUCCESS: {
      const dtoList = get(action, 'result.dtoList', [])

      return {
        ...state,
        loading: false,
        loaded: true,
        values: { ...state.values, ...mapDtoListToValues(dtoList) }
      }
    }
    case GET_CONFIG_KEY_VALUES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

function buildListRequest(orgId, cfgKeyList) {
  const data = {
    // FrontOffice never displays a configuration key's description - it is only used in BackOffice (customizations screen)
    // Only ConfigurationFile.handleOpenFile reads description, but that code is unreachable
    includeOverloadInfo: false,
    options: {
      getRecordList: true,
      getTotalCount: false
    }
  }

  // Omitted orgId means the API will resolve it from the access token
  if (orgId) {
    data.orgId = orgId
  }

  if (cfgKeyList && cfgKeyList.length) {
    data.cfgKeyList = cfgKeyList
  }

  return data
}

// Loads a specific set of configuration keys for an organization in a single call
export function getConfigurationValues(cfgKeyList, { organizationId, removeToken } = {}) {
  return {
    types: [
      GET_CONFIG_KEY_VALUES,
      GET_CONFIG_KEY_VALUES_SUCCESS,
      GET_CONFIG_KEY_VALUES_FAIL
    ],
    promise: client => client.post(
      'apiv2/configuration/organization/list',
      {
        data: buildListRequest(organizationId, cfgKeyList),
        removeToken: Boolean(removeToken)
      }
    ),
    organizationId
  }
}

// Loads a single configuration key for an organization
export function getConfigurationValue(name, { organizationId, removeToken } = {}) {
  return {
    types: [
      GET_CONFIG_KEY_VALUES,
      GET_CONFIG_KEY_VALUES_SUCCESS,
      GET_CONFIG_KEY_VALUES_FAIL
    ],
    promise: client => client.post(
      'apiv2/configuration/organization/list',
      {
        data: buildListRequest(organizationId, [name]),
        removeToken: Boolean(removeToken)
      }
    ),
    organizationId
  }
}
